import { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';

export const populateTemplates = (
  comparisonDateString: string,
  templateChartSeries: TemplateChartSeries[]
): TemplateChartSeries[] => {
  return templateChartSeries
    ?.map(template => {
      const temp = structuredClone(template);
      temp.symbol.transactionDate = comparisonDateString;
      return temp;
    })
    .filter(template => !!template);
};
